
console.log('Vite ⚡️ Rails')
import '@/app/main'